module.exports = __webpack_public_path__ + "img/icon_Liste.373c631f.svg";